import script from "./PrdDeveloperPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrdDeveloperPage.vue?vue&type=script&setup=true&lang=js"

import "./PrdDeveloperPage.vue?vue&type=style&index=0&id=938a7d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938a7d0a"]])

export default __exports__